// Common display messages use under `Devices` page
export const messages_common = {      
    firmware: 'Device firmware must be upgraded to use this feature.',
    select: 'Select a Position in the left menu to start.',
    save: 'Settings will not be implemented until Save is pressed.',
    overlap: 'Please edit the highlighted schedules so they do not overlap. Schedules cannot be saved when overlapping.',
    overlap_warning: 'The setup has Overlapping Schedules. You need to change your setup to remove the overlaps, before you proceed.'
}

// Common display messages use under `NX-42WRAudio` tab on `Devices` page
export const messages_audio = {
    disabled: 'Wave Recording control must be set to ‘Server’ in the Monitor Profile to use this feature.',
    not_capable: 'Device firmware must be upgraded and Rion NX-42WR option must be installed in order to use this feature.',
    no_service: 'This device does not support NX-42WR Audio Recording.', 
}

// Common display messages use under `Power` tab on `Devices` page
export const messages_power = {
    co_located: 'Power Management should be configured on the primary position.',
    no_service: 'This device does not support Power Management.',
    power_saving: 'In Power saving mode, buffered data is upload during the last 10 minutes of each hour.'
}

// Common display messages use under `Weekly Restart` tab on `Devices` page
export const messages_reboot = {
    co_located: 'Weekly Restart should be configured on the primary position.',
    disabled: 'Weekly Restart has been disabled, please contact ANV if this is incorrect.',
    no_service: 'Weekly Restart has been disabled, please contact ANV if this is incorrect.',
    description: 'The unit will stop measuring, update the time and restart measuring at the indicated time.',
    limitation: 'This feature cannot be disabled by users.'
}

// Common display messages use under `DND` tab on `Devices` page
export const messages_quiet_periods = {
    description: 'No email alerts will be sent during Do Not Disturb (DND) periods. A list of exceedance alerts is e-mailed at the end of each DND period.'
}

// Common display messages use under `Capabilities` tab on `Devices` page
export const messages_capabilities = {
    co_located: 'Check capabilities on the primary position.',
}
